<template>
  <Flex direction="column">
    <BaseText>
      {{ $t('subscription.cancelation_flow.cancel_confirmation_form.header') }}
    </BaseText>
    <BaseInput
      v-model="modelValue.otherSoftware"
      :label="
        $t(
          'subscription.cancelation_flow.cancel_confirmation_form.other_software_label'
        )
      "
      v-test="'cancel-subscription-other-solution'"
    />
    <BaseInput
      v-model="modelValue.explanation"
      :label="
        $t(
          'subscription.cancelation_flow.cancel_confirmation_form.explanation_label'
        )
      "
      v-test="'cancel-subscription-explanation'"
    />
    <BaseText>
      {{ $t(
        'subscription.cancelation_flow.cancel_confirmation_form.password_disclaimer'
      ) }}
    </BaseText>
    <BaseInput
      v-model="modelValue.password"
      :label="$t('global.password')"
      type="password"
      required
      v-test="'cancel-subscription-password'"
    />
  </Flex>
</template>

<script
  lang="ts"
  setup
>
defineProps<{
  modelValue: {
    otherSoftware: string;
    explanation: string;
    password: string;
  };
}>();
</script>
